// skipcq: JS-W1028, JS-0128
import { useCallback, useEffect, useState } from 'react';
import {
  collection,
  getDocs,
  onSnapshot,
  orderBy,
  query,
} from 'firebase/firestore';
import * as Sentry from '@sentry/react';
import { db } from '../utils/firebase';

function mapTypeDocs(snapshot) {
  return snapshot.docs.map((docSnapshot) => ({
    id: docSnapshot.id,
    ...docSnapshot.data(),
  }));
}

/**
 * Loads the beerStyleTypes allowlist.
 */
function useBeerStyleTypes() {
  const [styleTypes, setStyleTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const typesRef = collection(db, 'beerStyleTypes');
      const typesQuery = query(typesRef, orderBy('sortOrder', 'asc'));
      const snapshot = await getDocs(typesQuery);
      const rows = mapTypeDocs(snapshot);
      setStyleTypes(rows);
      return rows;
    } catch (err) {
      Sentry.captureException(err);
      setError('Failed to load style types');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const typesRef = collection(db, 'beerStyleTypes');
    const typesQuery = query(typesRef, orderBy('sortOrder', 'asc'));
    const unsubscribe = onSnapshot(
      typesQuery,
      (snapshot) => {
        setStyleTypes(mapTypeDocs(snapshot));
        setLoading(false);
      },
      (err) => {
        Sentry.captureException(err);
        setError('Failed to load style types');
        setStyleTypes([]);
        setLoading(false);
      },
    );
    return () => unsubscribe();
  }, []);

  return { styleTypes, loading, error, refresh };
}

export default useBeerStyleTypes;
